import React, { useState, useEffect } from 'react'
import style from './style.module.scss'
import 'react-image-crop/dist/ReactCrop.css'
import Cropper from 'react-easy-crop'
import { Text } from '@crossfit/design-system'
import { ReactComponent as DragIcon } from './drag.svg'
import { getCroppedImg } from './utils'
import { readFile } from './readFile'

const ImageCrop = ({
  file,
  onCrop,
  aspectRatio,
  zoomValue,
  setZoomValue,
  disableGrid,
}: {
  file?: File
  onCrop: (file: File) => void
  aspectRatio?: number
  zoomValue?: number
  setZoomValue?: (number) => void
  disableGrid?: boolean
}) => {
  const [imgSrc, setImgSrc] = useState('')
  const [cropper, setCropper] = useState({ x: 0, y: 0 })
  const [zoom, setZoom] = useState(1)

  useEffect(() => {
    const setImage = async () => {
      if (file) {
        const imgSrc = await readFile(file)
        setImgSrc(imgSrc)
      }
    }

    setImage()
  }, [file])

  return (
    <div className={style.cropContainer}>
      {!disableGrid && (
        <div className={style.dragBox} aria-hidden='true'>
          <DragIcon />
          <Text type='body' size='sm'>
            Drag to reposition
          </Text>
        </div>
      )}

      {disableGrid ? (
        <img src={imgSrc} className={style.cropImage} />
      ) : (
        <Cropper
          image={imgSrc}
          crop={cropper}
          zoom={zoomValue ? zoomValue : zoom}
          onCropChange={setCropper}
          aspect={aspectRatio}
          showGrid={false}
          objectFit='cover'
          onCropComplete={async (area, croppedAreaPixels) => {
            const croppedImage = await getCroppedImg(
              imgSrc,
              croppedAreaPixels,
              file.name,
            )
            onCrop(croppedImage)
          }}
          onZoomChange={setZoomValue ? setZoomValue : setZoom}
        />
      )}
    </div>
  )
}

export default ImageCrop
